<template>
  <nuttrema-layout-form-standard :edit="true" :theme="theme">
    <template slot="center">

      <el-form
         label-width="25%"
        :ref="formRef"
        :rules="rules"
        :model="formData"
        :label-position="labelPosition">

        <section>
          <template>
            <el-row type="flex" justify="center">
              <el-col :xs="24" :md="16">
                <nuttrema-jumbotron>
                  <h4>{{ $t('label.purchase_confirmation_email_not_arrive') }}</h4>
                </nuttrema-jumbotron>
              </el-col>
            </el-row>

            <el-row v-if="_get(ResendCompletionToken, 'error')" type="flex" justify="center">
              <el-col :xs="24" :md="12" style="margin-bottom: 1em">
                <nuttrema-form-alert
                   type="pink"
                   icon="far fa-exclamation"
                   icon-class-name="is-error"
                  :error="_get(ResendCompletionToken, 'error')"
                  :text="_get(ResendCompletionToken, 'error')">
                </nuttrema-form-alert>
              </el-col>
            </el-row>

            <div class="section-items">
              <el-form-item :label="$t('label.email')" prop="email">
                <el-col :xs="22" :md="16">
                  <el-input v-model="formData.email" :placeholder="$t('label.type_in_your_email_and_start_finish_instance_registration')"></el-input>
                </el-col>
              </el-form-item>

             <el-form-item>
                <el-col :xs="22" :md="16">
                  <el-button
                     type="nuttrema-dark-gray"
                     class="w-100"
                    :loading="isSaving"
                    @click="submitForm">
                    {{ $t('label.send_complete_registration_email') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </div>
          </template>

          <div class="section-help" style="margin-top: 2em">

            <el-row>
              <el-col :xs="16" :md="24" style="text-align: center">
                <router-link
                   class="el-button el-button--text"
                  :to="{ name: 'professional-login' }">
                  <i class="far fa-chevron-left" style="margin-right: 0.75em"></i>{{ $t('label.back_to', { label:  $t('label.login')}) | title-case }}
                </router-link>
              </el-col>
            </el-row>

          </div>
          <!-- end ~ section-help -->

        </section>
      </el-form>

    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

import NuttremaJumbotron from 'components/ui/panels/nuttrema-jumbotron';

import NuttremaNotification from 'components/ui/alert/nuttrema-notification';
import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';

export default {
  name: 'form-resend-completion-token',
  mixins: [FormStandardBehavior],
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    ResendCompletionToken: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaFormAlert,
    NuttremaJumbotron,
    NuttremaNotification,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        email: null,
      },
      rules: {
        email: [
          { required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.email', true),
          },
          { type: 'email',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.invalid', 'label.email', true),
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return this.clone(this.formData);
    },
  },
  created() {
    this.formRef = 'form-resend-completion-token';
    this.stateData = this.ResendCompletionToken;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/resend-completion-token/form-resend-completion-token.vue